import { useState } from "react";
import { useTranslate } from "@refinedev/core";
import { Button, Modal, SettingsTileCard, SwapIcon } from "@fawkes/ui";

import { SettingsTileComingSoon } from "../SettingsTileComingSoon";
import { IntegrationsManagement } from "../IntegrationsManagement";
import type { TileComponentProps } from "./types";

// Koppelingen — external integrations. Present in both contexts:
//   • Organisation → AI koppeling, migrated → opens the in-SPA detail screen (jve-settings-ai).
//   • Vestiging   → the migrated payment/device integrations (iDEAL/Mollie, PIN, PetBase) in a modal
//     (settings-integraties). A branch without a vestigingId falls back to the coming-soon dialog.
export const INTEGRATIONS_TILE_KEY = "integrations";

const ORG_ITEM_KEYS = ["instellingen.item.aiKoppeling"];
const BRANCH_ITEM_KEYS = [
  "instellingen.item.idealMollie",
  "instellingen.item.pinapparaat",
  "instellingen.item.petbase",
];

export function IntegrationsTile({ context, onOpenDetail }: TileComponentProps) {
  const t = useTranslate();
  const [open, setOpen] = useState(false);
  const isBranch = context.type === "branch";
  const itemKeys = isBranch ? BRANCH_ITEM_KEYS : ORG_ITEM_KEYS;

  return (
    <>
      <SettingsTileCard
        tileKey={INTEGRATIONS_TILE_KEY}
        icon={<SwapIcon className="settings-tile-icon" width={16} height={16} />}
        title={t("instellingen.tile.integrations.title")}
        description={t("instellingen.tile.integrations.desc")}
        items={itemKeys.map((k) => t(k))}
        openLabel={t("instellingen.cta.open")}
        // Organisation opens the migrated AI-koppeling detail; a branch opens the integrations modal.
        onOpen={() => (isBranch ? setOpen(true) : onOpenDetail("ai-koppeling"))}
      />
      {isBranch && context.vestigingId !== null ? (
        // Branch context = the migrated Koppelingen detail: the three integration cards.
        <Modal
          open={open}
          title={t("instellingen.tile.integrations.title")}
          onClose={() => setOpen(false)}
          footer={
            <Button variant="secondary" onClick={() => setOpen(false)}>
              {t("common.back")}
            </Button>
          }
        >
          <div className="settings-tile-modal">
            <p className="settings-tile-modal-breadcrumb">
              {`${t("instellingen.title")} › ${context.label} › ${t("instellingen.tile.integrations.title")}`}
            </p>
            <IntegrationsManagement vestigingId={context.vestigingId} />
          </div>
        </Modal>
      ) : (
        // Fallback (e.g. a branch with no vestigingId) → coming soon.
        <SettingsTileComingSoon
          open={open}
          onClose={() => setOpen(false)}
          titleKey="instellingen.tile.integrations.title"
          itemKeys={itemKeys}
          context={context}
        />
      )}
    </>
  );
}
